import { PriceEstimationRequest } from "../models/priceEstimationRequest.ts";
import { PriceResponse } from "../models/priceResponse.ts";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";
import { useCallback } from "react";

export const useEstimatePrice = () => {
  const { handle } = useMessageHandler();

  const estimatePrice = useCallback(async (
    payload: PriceEstimationRequest
  ): Promise<PriceResponse | null> => {
    return await handle(async () => {
      const response = await apiJson.post("/price/estimate", payload);
      return response.data;
    }).catch(() => null);
  }, [handle]);

  return { estimatePrice };
};
